"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DadataService = void 0;
const BaseRestService_1 = __importDefault(require("../BaseRestService"));
const axios_1 = __importDefault(require("axios"));
const DadataAddressSuggestions_1 = require("../../data/dadata/DadataAddressSuggestions");
const utils_1 = require("@sqvr/utils");
class DadataService extends BaseRestService_1.default {
  constructor() {
    super(...arguments);
    this.customApiPath = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest';
    this.searchAddress = (text, max = 10, fromBound = DadataAddressSuggestions_1.DADATA_ADDRESS_SEARCH_BOUND_COUNTRY, toBound = DadataAddressSuggestions_1.DADATA_ADDRESS_SEARCH_BOUND_HOUSE) => __awaiter(this, void 0, void 0, function* () {
      if (!utils_1.appConfig.dadataToken) {
        console.log('Can not search with the dadata without an auth token');
        return Promise.resolve([]);
      }
      const requestParams = {
        query: text,
        count: max,
        from_bound: {
          value: fromBound
        },
        to_bound: {
          value: toBound
        }
      };
      const {
        data
      } = yield axios_1.default.post(this.customApiPath + '/address', requestParams, {
        headers: {
          Authorization: `Token ${utils_1.appConfig.dadataToken}`,
          'Content-Type': 'application/json'
        }
      });
      return Promise.resolve(data.suggestions);
    });
    this.searchUsefulAddress = (text, max = 10, fiasId = '', fromBound = DadataAddressSuggestions_1.DADATA_ADDRESS_SEARCH_BOUND_STREET, toBound = DadataAddressSuggestions_1.DADATA_ADDRESS_SEARCH_BOUND_HOUSE) => __awaiter(this, void 0, void 0, function* () {
      if (!utils_1.appConfig.dadataToken) {
        console.log('Can not search with the dadata without an auth token');
        return Promise.resolve([]);
      }
      const requestParams = {
        query: text,
        count: max,
        from_bound: fiasId ? {
          value: fromBound
        } : undefined,
        to_bound: fiasId ? {
          value: toBound
        } : undefined,
        locations: [{
          fias_id: fiasId
        }]
      };
      const {
        data
      } = yield axios_1.default.post(this.customApiPath + '/address', requestParams, {
        headers: {
          Authorization: `Token ${utils_1.appConfig.dadataToken}`,
          'Content-Type': 'application/json'
        }
      });
      return Promise.resolve(data.suggestions);
    });
  }
}
exports.DadataService = DadataService;
const dadataService = new DadataService();
exports.default = dadataService;